import { HTMLELEMENT } from '../../../EL/EL.js';
import DIV, { div } from '../../../DOM/div/DIV.js';
import HEADER from '../../../DOM/header/HEADER.js';
import GROUP from '../../../DOM/GROUP/GROUP.js';
import { text } from '../../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const listGroupAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const listGroupData = makeDataStruct([
    ['header', text()],
    ['lists', []]
]);
export const listGroupModel = makeStruct([
    ['attributes', listGroupAttr],
    ['data', listGroupData]
]);
// Simple Model
export function listGroup(header, lists, name, className) {
    return {
        attributes: listGroupAttr(name, className),
        data: listGroupData(header, lists)
    };
}
/** A group of Lists */
export default class LISTGROUP extends GROUP {
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
        this.addClass('list-group');
        this.header = new HEADER(this, model.data.header);
        this.group = new DIV(this, div());
    }
}
